<template>
  <div>
    <b-loading is-full-page :active.sync="isLoading"></b-loading>
    <section v-if="offer" class="section">
      <div class="container">
        <div class="content aeisep_offer-title">
          <h1 class="title">
            {{ offer.fields.company.fields.name }}
          </h1>
          <p class="subtitle">{{ offer.fields.title }}</p>
          <div>
            <button class="button aeisep_btn" @click="$router.go(-1)">
              <p><a>← Voltar</a></p>
            </button>
          </div>

          <strong>Descrição:</strong>
          <div class="content">
            <vue-markdown breaks>{{ offer.fields.description }}</vue-markdown>
          </div>

          <strong>Adicionada a:</strong>
          <p>
            <time>
              {{ offer.sys.createdAt | moment("LL") }}
            </time>
          </p>

          <strong v-if="offer.fields.categories.length > 1">Categorias:</strong>
          <strong v-else>Categoria:</strong>
          <b-taglist>
            <b-tag
              class="is-primary"
              v-for="(category, key) in offer.fields.categories"
              :key="'category_' + key"
            >
              {{ category.fields.name }}
            </b-tag>
          </b-taglist>

          <strong>Tags:</strong>
          <b-taglist>
            <div v-if="offer.fields.tags">
              <b-tag
                v-for="(tag, key) in offer.fields.tags"
                :key="'tag_' + key"
              >
                {{ tag }}
              </b-tag>
            </div>
          </b-taglist>

          <strong>Como candidatar:</strong>
          <p v-if="offer.howToApply" style="margin-bottom: 0">
            {{ offer.howToApply }}
          </p>
          <div v-if="offer.fields.applyMethod">
            <b-field
              v-if="
                offer.fields.applyMethod.sys.contentType.sys.id ===
                'applyMethodLink'
              "
            >
              <b-input
                disabled
                expanded
                :value="offer.fields.applyMethod.fields.link"
              >
              </b-input>
              <p class="control">
                <a :href="offer.fields.applyMethod.fields.link" target="_blank">
                  <button class="button is-primary">Abrir URL</button>
                </a>
              </p>
            </b-field>
            <b-field
              v-else-if="
                offer.fields.applyMethod.sys.contentType.sys.id ===
                'applyMethodEmail'
              "
            >
              <b-input
                disabled
                expanded
                :value="offer.fields.applyMethod.fields.email"
              >
              </b-input>
              <p class="control">
                <button
                  class="button is-primary"
                  v-clipboard:copy="offer.fields.applyMethod.fields.email"
                  v-clipboard:success="onCopy"
                  v-clipboard:error="onErrorCopy"
                >
                  Copiar email
                </button>
              </p>
            </b-field>
          </div>
          <div v-else>
            <b-field>
              <b-input
                disabled
                expanded
                :value="offer.fields.company.fields.email"
              >
              </b-input>
              <p class="control">
                <button
                  class="button is-primary"
                  v-clipboard:copy="offer.fields.company.fields.email"
                  v-clipboard:success="onCopy"
                  v-clipboard:error="onErrorCopy"
                >
                  Copiar email
                </button>
              </p>
            </b-field>
          </div>
          <div>
            <button class="button aeisep_btn" @click="$router.go(-1)">
              <p><a>← Voltar</a></p>
            </button>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import VueMarkdown from "vue-markdown";

const contentful = require("contentful");

const client = contentful.createClient({
  space: "7lnt6blrx994",
  accessToken:
    "6d95436eca873871002a45d853336517f9a1cce20c7c1b20e471b2f87eb2f2c9",
});

export default {
  name: "offer-component",
  components: { VueMarkdown },
  props: {
    offerId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      offer: null,
      isLoading: true,
    };
  },
  mounted() {
    client.getEntry(this.offerId).then((entry) => {
      this.offer = entry;
      this.isLoading = false;
    });
  },
  methods: {
    onCopy() {
      this.$toast.open({
        message: "Email copiado para o clipboard!",
        position: "is-bottom",
      });
    },
    onErrorCopy() {
      this.$toast.open({
        message: "Erro ao copiar email!",
        position: "is-bottom",
        type: "is-danger",
      });
    },
  },
};
</script>

<style scoped>
.aeisep_offer-title {
  background-color: #8b8b8b0c;
  padding: 20px;
}
.aeisep_btn {
  margin: 20px 0px 20px 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/OfferComponent.vue